import { render, staticRenderFns } from "./PreviewScreen.vue?vue&type=template&id=3ed50158&scoped=true&"
import script from "./PreviewScreen.vue?vue&type=script&lang=js&"
export * from "./PreviewScreen.vue?vue&type=script&lang=js&"
import style0 from "./PreviewScreen.vue?vue&type=style&index=0&id=3ed50158&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed50158",
  null
  
)

export default component.exports